import game from '../Game/GameInstance'
import axios from 'axios'
import Person from '../Models/Person'
import ImageContainer from '../Images/ImageContainer'

let interval = 6000;

class Repository
{

  constructor() {
    this.items = [];
    this.indicesById = {};
  }


  garbageCollect() {
    this.items = [];
  }

  push(item) {

    let i = this.items.length;
    while (i--) {

      if (this.items[i].data.id === item.id) {
        this.updateItem(i, item);

        setTimeout(() => {
          if (this.items[i]) {
            this.items[i].moveToRoom(this.findRoom(item.room_id));
          }
        }, Math.random() * interval);

        return;
      }

    }

    let person = new Person(item, 32, game);

    this.items.push(person);
    if (game.layers.people) {
      game.layers.people.push(person);
    }
    game.people.push(person);

    person.moveToRoom(this.findRoom(item.room_id));

  }

  updateItem(index, item)
  {

    let compareFields = ['first_name', 'last_name', 'image_url'];
    let model = this.items[index];
    let imageChanged = false;
    let changed = false;

    compareFields.forEach((i) => {

      if (model.data[i] !== item[i]) {

        changed = true;
        model.data[i] = item[i];
        model.needsRendering = true;

        if (i === 'image_url') {
          imageChanged = true;
        }

      }

    });

    if (imageChanged) {

      if (model.data.image_url) {
        model.imageObject = ImageContainer.getInstance().image(model.data.image_url);
        model.imageObject.load().then((image) => {
          model.needsRendering = true;
        });
        return;
      }

      model.imageObject = null;


    }

  }

  findRoom(room_id) {

    if (!room_id) {
      return null;
    }

    let i = game.rooms.length;
    while(i--) {

      if (game.rooms[i].data.id === room_id) {
        return game.rooms[i];
      }

      if (game.rooms[i].data.children) {
        let j = game.rooms[i].data.children.length;
        while(j--) {

          if (game.rooms[i].data.children[j].id === room_id) {
            game.rooms[i].data.children[j].parent = game.rooms[i];
            return game.rooms[i].data.children[j];
          }

        }
      }
    }

    if(room_id !== 'lobby'){
      return this.findRoom('lobby');
    }

  }
}

let store = new Repository();

export default class PersonUpdater
{

  constructor(apiBase) {

    this.endpoint = apiBase + 'incremental-people';
    this.lastUpdate = null;
    this.paused = true;
    this.timeout = null;

  }

  garbageCollect() {
    store.garbageCollect();

  }


  pause() {

    if (!this.paused) {
      this.paused = true;
      clearTimeout(this.timeout);
      return;
    }

    console.warn('Cannot pause PersonUpdater: already paused!');

  }

  resume() {

    if (this.paused) {
      this.paused = false;
      this.lastUpdate = null;
      this.scheduleNextStep()
      return;
    }

    console.warn('Cannot pause PersonUpdater: already running!');

  }

  scheduleNextStep(){

    if(this.paused === false){
      this.update().finally(() => {
        this.timeout = setTimeout(() => this.scheduleNextStep(), 5000);
      })
    }
  }


  roomsLoaded() {
    // rooms have loaded; this is the first time our people can be placed somewhere
    this.firstRun();
  }

  firstRun() {

    this.update();
    this.resume();

  }

  update() {

    let endpoint = this.endpoint;
    if (this.lastUpdate) {
      if (endpoint.indexOf('?') === -1) {
        endpoint += '?from=' + this.lastUpdate;
      }
      else{
        endpoint += '&from=' + this.lastUpdate;
      }
    }

    return RequestHelperInstance
      .get(endpoint)
      .then((response) => {

        response.forEach(person => {
          store.push(person);
        });

      });

  }

}
